module.exports = __webpack_public_path__ + "media/images/openweather/mapicons/catalonia-a3c1fd4bb83eb039c97d785865f4c72c.png";